import { useEffect, useState } from 'react';
import { SnapshotDateRange } from 'src/components/star-grid/reportSelectors.types';
import { VERSION_SNAPSHOT_PREVIEW_LIMIT, VERSION_TAG_PREVIEW_LIMIT } from 'src/components/star-grid/versionDateFilterConstants';
import { buildVersionCatalog } from 'src/components/star-grid/utils/versionCatalog';

type VersionCatalog = ReturnType<typeof buildVersionCatalog>;

export const useVersionHistoryPreview = (catalog: VersionCatalog, range: SnapshotDateRange, query: string, isOpen: boolean) => {
  const [showTags, setShowTags] = useState(false);
  const [showSnapshots, setShowSnapshots] = useState(false);
  useEffect(() => setShowTags(false), [query, isOpen]);
  useEffect(() => setShowSnapshots(false), [range, query, isOpen]);
  return {
    showTags,
    showSnapshots,
    tags: showTags ? catalog.tagged : catalog.tagged.slice(0, VERSION_TAG_PREVIEW_LIMIT),
    snapshots: showSnapshots ? catalog.snapshots : catalog.snapshots.slice(0, VERSION_SNAPSHOT_PREVIEW_LIMIT),
    remainingTags: Math.max(0, catalog.tagged.length - VERSION_TAG_PREVIEW_LIMIT),
    remainingSnapshots: Math.max(0, catalog.snapshots.length - VERSION_SNAPSHOT_PREVIEW_LIMIT),
    toggleTags: () => setShowTags((current) => !current),
    toggleSnapshots: () => setShowSnapshots((current) => !current)
  };
};
